export default "__VITE_ASSET__ClHmr9RD__"